import * as React from "react"

import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"

import { Svg } from "styleguide/components"

const IconCross = ({
  title = "Cross",
  color = "darkerRed",
  viewBoxWidth = 64,
  viewBoxHeight = 64,
  ...otherProps
}: SvgIconProps) => (
  <Svg.Icon {...{ title, viewBoxHeight, viewBoxWidth, color, ...otherProps }}>
    <path
      d="M2 24h22V2a2 2 0 012-2h12a2 2 0 012 2v22h22a2 2 0 012 2v12a2 2 0 01-2 2H40v22a2 2 0 01-2 2H26a2 2 0 01-2-2V40H2a2 2 0 01-2-2V26a2 2 0 012-2z"
      fill="#B11100"
      fillRule="evenodd"
    />
  </Svg.Icon>
)

export default IconCross
